import { StepAction } from './stepAction';
import { getLogger } from '../../commons/logger';
import { featureFlagsService } from '../../commons/featureFlagsService';
import type { DropFileStep } from 'clickim/src/common/models/dropFileStep';

const logger = getLogger('drop-file-step-action');

export class DropFileStepAction extends StepAction<DropFileStep> {
    override async performAction() {
        const { sessionPlayerInit: { codeSnippets, utils }, context, step } = this;
        const target = this.getTarget();
        const overrideAzureStorageUrl = featureFlagsService.flags.overrideAzureStorageUrl.isEnabled();
        const fileUrls = await utils.addTokenToFileUrls(
            context.project.id,
            step.fileUrls!,
            this.stepActionUtils.testimServicesApi,
            overrideAzureStorageUrl,
            logger,
        );
        const { downloadFileAndFireDropEvent } = await import('./scripts/dropEvent');

        const dropFileCode = `
            const getLocatedElement = ${codeSnippets.getLocatedElementCode};
            const createDropEvent = ${codeSnippets.createDropEvent.toString()};
            const downloadFileAndFireDropEvent = ${downloadFileAndFireDropEvent.toString()};
            return downloadFileAndFireDropEvent.apply(null, arguments)
        `;

        return await this.driver.executeJS<typeof downloadFileAndFireDropEvent>(dropFileCode, target.locatedElement, fileUrls);
    }
}
